//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qrcodeImg from '@assets/img/qrcode_search_green.png'
import SimplePage from '@/components/SimplePage'
import {
  isWeixin
} from '@utils'
import {
  oAuth
} from '@utils/wechat'
import wechat from '@utils/wechat'
import toLogin from '@utils/login'
export default {
  name: 'App',
  components: {
    SimplePage
  },
  data() {
    return {
      qrcodeImg: qrcodeImg,
      isWx: false,
      isView: false,
      isPremission: true,
      loadingText: ''
    }
  },
  watch: {
    $route(current, before) {
      // 当前页面需要登录，则根据情况判断是否需要检测各种情况
      if (!this.isWx || !this.needLogin) {
        this.setPrjCode();
        this.initApp();
      } else if (this.needLogin) {
        if (this.token && this.subscribe !== null) this.setPremission()
        else this.checkLogin()
      }

    }
  },
  computed: {
    route_name() {
      return this.$route.name
    },
    subscribe() {
      // 已登录且未关注提示去关注
      return this.$store.state.app.subscribe
    },
    token() {
      return !!this.$store.state.app.token
    },
    needLogin() {
      return this.$route.meta.login !== false
    }
  },
  created() {
    this.isWx = isWeixin();
    this.setPrjCode();
    this.initApp();
  },
  methods: {
    initApp() {
      if (!this.needLogin) this.renderApp()
      else if (this.isWx && this.token) this.checkLogin()
      else if (this.isWx && !this.token) toLogin()
    },
    checkLogin() {
      let _this = this
      this.$post('/ashx/wxHelper.ashx?action=Exist', {PRJ_CODE: this.$store.state.app.prj_code}).then(res => {
        if (!res.openid) _this.$store.commit('LOGOUT')
        if (res.subscribe !== 1) res.subscribe = 0;
        _this.$store.commit('setAppData', res);
        _this.setPremission()
        if (_this.subscribe == 1 && _this.isPremission) _this.renderApp();
      }).catch(res => {
        _this.loadingText = res.Msg || res.msg || '请求出错';
      })
    },
    renderApp() {
      this.isView = true
    },
    setPremission() {
      let isp = true
      if (!this.needLogin || this.$store.state.app.roleid === null || this.$store.state.app.roleid > 0) {
        isp = true
      } else {
        let role = this.$route.meta.role || []
        let roleid = parseInt(this.$store.state.app.roleid)
        console.log(this.$route,role, roleid)
        isp = role.indexOf(roleid) != -1 // 是否有权限
      }
      //this.isPremission = isp
      this.isPremission=true
    },
    setPrjCode() {
      let path = this.$route.path;
      let prj = path.split('/')[1];
      if (this.$config.PRJ.indexOf(prj) === -1) {
        prj = 'bmw';
      }
      this.$store.commit('setPrjCode', prj)
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue